<template>
	<page-container :page="page">
		<main-content
			:title="page.title || page.header"
			:color="page.color"
			:content="page.content"
			:heading-image="page.headingImages && page.headingImages[0]"
		/>

		<div v-if="page.showIntakeForm" class="main-content eventform-wrapper">
			<div class="row align-center">
				<div
					class="columns column12"
					style="max-width: 600px; margin: 0 auto; display: inline-block; float: none"
				>
					<iframe
						src="https://app.eventtemple.com/lead_intakes/142e4ea61816334c3998660452a49a90/7497/new"
						width="100%"
						height="800px"
						frameborder="0"
					></iframe>
				</div>
			</div>
		</div>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>
